import { render, staticRenderFns } from "./thankBox.vue?vue&type=template&id=57f0b1b4&scoped=true"
import script from "./thankBox.vue?vue&type=script&lang=js"
export * from "./thankBox.vue?vue&type=script&lang=js"
import style0 from "./thankBox.vue?vue&type=style&index=0&id=57f0b1b4&prod&lang=scss"
import style1 from "./thankBox.vue?vue&type=style&index=1&id=57f0b1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0b1b4",
  null
  
)

export default component.exports